<template>
  <div class="item-box">
    <div class="item-head disFlex Flex-center Flex-between" @click="goDetail">
      <div class="item-id">订单号：{{item.tradeNo}}</div>
      <div class="item-status">{{item.payStatus?'已付款':'未付款'}}</div>
    </div>
    <div class="item-body disFlex Flex-center" @click="goDetail">
      <div class="item-left">
        <img
          :src="item.pic||'https://j.weizan.cn/zhibo/livecontent/lottery/images/lotteryShare.jpg'"
          class="item-img"
        />
        <!-- <div class="item-data disFlex Flex-center fvc">
          已抢
          <span class="num">1</span>件,剩
          <span class="num">1</span>件
        </div>-->
      </div>
      <div class="item-right disFlex vertical fbt">
        <div class="item-top disFlex Flex-center Flex-between">
          <div class="item-title clamp1">{{item.productName}}</div>
          <div class="item-num">x{{item.num}}</div>
        </div>
        <img :src="item.brandLogo" class="item-info" v-if="item.brandLogo" />
        <div class="item-detail disFlex Flex-center Flex-between">
          <div class="price-area disFlex Flex-center">
            <div class="price-detail">下订价：{{item.seckillPrice}} 丨 直播价：{{item.salePrice}}</div>
          </div>
          <div class="options-area">
            <div
              class="options-btn"
              v-if="item.status==='finish'"
              @click.stop.prevent="viewDetail"
            >查看详情</div>
            <div class="options-btn" v-if="item.status==='active'" @click.stop.prevent="goCheck">核销</div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="showqrcode" :close-on-click-overlay="true" :show-confirm-button="false">
      <div style="width:80%;margin:10px auto">
        <img :src="qrcode" style="width:100%" alt="图片加载中，请稍后" />
        <div class="tip">出示给导购员进行扫码核销</div>
      </div>
    </van-dialog>
    <van-dialog v-model="showDetail" :close-on-click-overlay="true" title="使用详情">
      <div class="check-detail" v-if="kpiUserAmountVo">
        <p>
          <span>核销时间：</span>
          {{kpiUserAmountVo.finishTime}}
        </p>
        <p>
          <span>核销导购员：</span>
          {{kpiUserAmountVo.kpiUserName}}
        </p>
        <p>
          <span>核销门店：</span>
          {{kpiUserAmountVo.shopName||'-'}}
        </p>
        <p>
          <span>核销品牌：</span>
          {{kpiUserAmountVo.brandName||'-'}}
        </p>
        <p>
          <span>转单金额：</span>
          {{kpiUserAmountVo.changeAmount}}
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showqrcode: false,
      showDetail: false,
      kpiUserAmountVo: null,
      qrcode: "",
    };
  },
  methods: {
    goDetail() {
      this.$router.push({
        path: "/my/orderDetail",
        query: {
          id: this.item.id,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    goCheck() {
      this.getQrCode().then((res) => {
        this.qrcode = res.data.qrcodePath;
        this.showqrcode = true;
      });
    },
    getQrCode() {
      const that = this;
      return new Promise((resolve) => {
        this.$http
          .get("/v1/qrcode/gen_code", {
            scene: "live_order_finish",
            addition: encodeURIComponent(
              JSON.stringify({
                id: that.item.id,
                tradeNo: that.item.tradeNo,
              })
            ),
          })
          .then((res) => {
            resolve(res);
          });
      });
    },
    viewDetail() {
      const that = this;
      that.$http
        .post(`/v1/orders/live_order_detail?orderId=${that.item.id}`, {})
        .then((res) => {
          if (res.code === 0) {
            that.kpiUserAmountVo = res.data.kpiUserAmountVo;
            that.showDetail = true;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.item-box {
  width: 100%;
  padding: 0 15px 15px;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 5px;
  .item-head {
    height: 41px;
    border-bottom: 1px solid #f5f6f7;
    margin-bottom: 15px;
    .item-id {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(105, 105, 105, 1);
    }
    .item-status {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
  }
  .item-left {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
    .item-img {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    .item-data {
      width: 100px;
      height: 22px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.3;
      border-radius: 0 0 5px 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      .num {
        color: #fcff00;
      }
    }
  }
  .item-right {
    width: 100%;
    margin-left: 10px;
    height: 100px;
    .item-info {
      width: 58.5px;
      height: 33px;
      border-radius: 2px;
    }
    .item-num {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .item-title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      line-height: 24px;
    }
    .price-detail {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
    }
    .options-btn {
      width: 70px;
      height: 24px;
      background: rgba(0, 48, 120, 1);
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
      text-align: center;
    }
  }
  .tip {
    font-size: 16px;
  }
  .check-detail {
    font-size: 14px;
    line-height: 24px;
    padding: 0 10px;
    text-align: left;
    span {
      font-weight: 600;
    }
  }
}
</style>